import React from 'react'

import { BaseView } from './components'

import useFetch from 'hooks/useFetch'
import * as service from 'service'

const QuestionControlsShow = ({ match }) => {
  const {
    params: { questionControlId },
  } = match

  const { response, isLoading, refresh } = useFetch(
    service.dponet.questionControls.show,
    { questionControlId },
    [],
  )

  const { response: responseLogs, refresh: refreshLogs } = useFetch(
    service.dponet.questionControls.logs,
    { questionControlId },
    [],
  )

  return (
    <BaseView
      isEdit={false}
      questionControl={response?.data?.questionControl}
      logs={responseLogs?.data?.dponetAudits}
      isLoading={isLoading}
      refresh={refresh}
      refreshLogs={refreshLogs}
    />
  )
}

export default QuestionControlsShow
